import { render, staticRenderFns } from "./icon-bmp.vue?vue&type=template&id=b747f110&"
import script from "./icon-bmp.vue?vue&type=script&lang=js&"
export * from "./icon-bmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports